import { AddressDetails } from './address-details';

export interface PersonalDetails<T = string, U = Date> {
  firstName: T;
  lastName: T;
  birthDate: U | null;
  address: AddressDetails | null;
}
